"use client";

import { CART_COOKIE } from "@/config/cart";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { deleteCookie } from "cookies-next";
import { type ReactNode, useEffect, useState } from "react";

export default function ReactQueryClientProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            queryFn: () => null,
          },
        },
      }),
  );

  useEffect(() => {
    return queryClient.getQueryCache().subscribe((event) => {
      if (event?.type !== "updated") {
        return;
      }

      const { query } = event;
      const { status, error } = query.state;

      if (status === "error" && error?.message.includes("CART_NOT_FOUND")) {
        deleteCookie(CART_COOKIE);
        void queryClient.invalidateQueries({ queryKey: ["cart"] });
      }
    });
  }, [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
